import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { memo, useMemo } from "react";
import { dataPresentationPalette } from "../../../shared/constants/dataPresentationPalette";
import useStyles from "./useStyles";
import { useSelector } from "react-redux";
import TableHead from "@mui/material/TableHead";
import { getShortNameOfGeoobjectByTitle } from "../../../shared/helpers/getShortNameOfGeoobjectByTitle";

const mapStateToProps = (state) => {
  const { api: { geoObjs } = {}, ui: { selectedGeoObjArray } = {} } = state;
  return {
    geoObjs,
    selectedGeoObjArray,
  };
};

const TimeTable = (props) => {

    const classes = useStyles()

    const {
    } = useSelector(mapStateToProps)

  const {
    dataArr,
  } = props


    return (
        <>
          <TableContainer
              component={Paper}
              className={classes.tableContainer}
          >
            <Table
                aria-label="simple table"
                className={classes.table}
            >
               <TableHead className={classes.tableHeader} sx={{}}>
                    <TableRow>
                        <TableCell colSpan={2} align={'left'}>№ {getShortNameOfGeoobjectByTitle(dataArr?.[1]?.textValue)}</TableCell>
                    </TableRow>
                </TableHead>
              <TableBody>
                {dataArr.map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{
                      backgroundColor: row.isHeader ? 'rgba(104, 154, 219, 0.2)' : undefined,
                      '&:last-child td, &:last-child th': { border: 0 },
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      style={{
                          color: `${dataPresentationPalette[row.id]}`,
                      }}
                    >
                      {row.label}
                    </TableCell>
                    <TableCell
                      align="right"
                    >{row.textValue}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
  )
}

export default memo(TimeTable);
